<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Borrowing History</h1>
      <v-divider></v-divider>
      <v-tabs v-model="tab">
        <v-tab v-for="item in items" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="pt-2">
        <v-tab-item><LendingOngoing /> </v-tab-item>
        <v-tab-item><LendingCompleted /></v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import LendingOngoing from "./../components/LendingOngoing";
import LendingStatus from "./../components/LendingStatus";
import LendingCompleted from "./../components/LendingCompleted";

export default {
  name: "Lending",
  components: {
    LendingOngoing,
    LendingStatus,
    LendingCompleted,
  },
  data() {
    return {
      tab: null,
      items: ["ONGOING ", "Completed"],
    };
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Lending.vue